import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const AuthLoadingScreen: React.FC<{ message: string }> = ({ message }) => (
    <Box
        sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2.5,
            bgcolor: 'background.default',
        }}
    >
        <Box
            component="img"
            src="/images/logo.png"
            alt=""
            aria-hidden
            sx={{ height: 48, opacity: 0.9 }}
        />
        <CircularProgress size={36} thickness={4} />
        <Typography variant="body1" color="text.secondary">
            {message}
        </Typography>
    </Box>
);

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading, isLoggingOut } = useAuth();

    if (isLoggingOut) {
        return <>{children}</>;
    }

    if (isLoading) {
        return <AuthLoadingScreen message="Loading…" />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
